import React from 'react';
import { LineChart } from '@mui/x-charts';
import { Box, Typography } from '@mui/material';


function TrendsLineChartForInvoiceComplexity({dataset, title,xAxisLabel}) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    // Format as '5 Jun'
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
  };

  return (
    <Box sx={{width: "100%", boxSizing: "border-box", padding: "24px", border: '1px solid #E5E5E5', borderRadius: '8px',backgroundColor: 'var(--white)'}}>
    <Typography variant="h6" component="h4" sx={{fontSize: '20px', fontWeight: 700, color: '#111', mb: 4}}>
        {title}
    </Typography>
    <LineChart
      dataset={dataset}
        xAxis={[
          {
            id: 'date',
            dataKey: 'date',
            scaleType: 'point',
            label:xAxisLabel,
            valueFormatter: (value, context) => {
              if (context.location === "tick") {
                return ""
              }
              return formatDate(value)
            }
          },
        ]}
        sx={{
          '& .MuiChartsAxis-root .MuiChartsAxis-line': { stroke: 'var(--grey-CCC)' },
          '& .MuiYAxis-root .MuiYAxis-line': { stroke: 'var(--grey-CCC)' },
          '& .MuiChartsAxis-root .MuiChartsAxis-tick': {stroke: 'var(--grey-CCC)' },
        }}
        yAxis={[{ width: 70, label: "Invoices" }]}
        series={[
          {
            id: 'Single_Po',
            label: 'Single PO',
            dataKey: 'single_po',
            stack: 'total',
            area: false,
            showMark: false,
            color: '#3C2676', 
          },
          {
            id: 'Multi_Po',
            label: 'Multi PO',
            dataKey: 'multi_po',
            stack: 'total',
            area: false,
            showMark: false,
            color: '#5D3EA8',
          },
          {
            id: 'Yet_To_Be_Extracted',
            label: 'Yet to be extracted',
            dataKey: 'yet_to_be_extracted',
            stack: 'total',
            area: false,
            showMark: false,
            color: '#8F7DC7', 
          },
          {
            id: 'Non_Po',
            label: 'Non PO',
            dataKey: 'non_po',
            stack: 'total',
            area: false,
            showMark: false,
            color: '#B6A9DB', 
          },
        ]}
        height={300}
    />
    </Box>
  );
}

export default TrendsLineChartForInvoiceComplexity;
